import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { BackButton } from "@/components/back-button";
import { generativeFilms } from "@/data/generative-films";

export const Route = createFileRoute("/visual-sensory-therapy")({
  head: () => ({
    meta: [
      {
        property: "og:url",
        content: "https://www.luizajesusdoprado.com/visual-sensory-therapy",
      },
      { title: "Visual and Sensory Therapy | Luiza Jesus do Prado" },
      {
        name: "description",
        content:
          "An immersive session from Ecologies of Perception: moving image and a continuous sound journey by Luiza Jesus do Prado.",
      },
      { property: "og:title", content: "Visual and Sensory Therapy | Luiza Jesus do Prado" },
      { property: "og:description", content: "Moving image and a continuous sound journey." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
    ],
  }),
  component: Therapy,
});

function Therapy() {
  const [on, setOn] = useState(false);
  const [film, setFilm] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setFilm((v) => (v + 1) % generativeFilms.length);
    }, 9000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="relative h-[100svh] w-full overflow-hidden bg-ink text-bone">
      <BackButton />

      {generativeFilms.map((src, i) => (
        <video
          key={src}
          src={src}
          loop
          muted
          playsInline
          preload="metadata"
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[2500ms] ${
            i === film ? "opacity-60" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-ink/55" />

      <div className="relative flex h-full flex-col items-center justify-center px-6 text-center">
        <Link
          to="/work/$slug"
          params={{ slug: "ecologies-of-perception" }}
          className="font-mono text-[9px] uppercase tracking-[0.3em] text-bone/70 underline underline-offset-4 transition-colors hover:text-bone"
        >
          Ecologies of Perception ↗
        </Link>
        <h1 className="mt-6 font-display text-[clamp(1.8rem,7vw,5rem)] font-light uppercase leading-[0.9] tracking-[0.02em]">
          Visual and
          <br />
          Sensory Therapy
        </h1>

        <button
          type="button"
          onClick={() => setOn((v) => !v)}
          aria-label={on ? "Pause session" : "Begin session"}
          className="group mt-12 flex h-16 w-16 items-center justify-center rounded-full border border-bone/30 transition-colors hover:border-bone"
        >
          {on ? (
            <span className="flex gap-[5px]">
              <span className="block h-4 w-[2px] bg-bone/80" />
              <span className="block h-4 w-[2px] bg-bone/80" />
            </span>
          ) : (
            <span className="ml-[3px] block h-0 w-0 border-y-[9px] border-l-[14px] border-y-transparent border-l-bone/80 transition-colors group-hover:border-l-bone" />
          )}
        </button>

        <p className="mt-6 font-mono text-[9px] uppercase tracking-[0.28em] text-bone/65">
          {on ? "Session running — headphones, low light" : "Begin"}
        </p>
      </div>

      {/* sound — discreet player at the base of the screen */}
      <div
        className={`absolute bottom-6 left-1/2 w-[min(520px,88vw)] -translate-x-1/2 transition-opacity duration-1000 ${
          on ? "opacity-70 hover:opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <iframe
          title="Sound journey"
          src="https://open.spotify.com/embed/track/4xQjMKXkLfeGf6ZgngZpOb?utm_source=generator&theme=0"
          height="80"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          className="w-full border-0"
        />
      </div>
    </div>
  );
}
